module.exports = __webpack_public_path__ + "img/Explore@4x.5ce8ab5a.png";